import React from "react";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import FilterListIcon from "@mui/icons-material/FilterList";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Box from "@mui/material/Box";

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFilterClick: () => void;
  isSmallScreenSearchBar: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchQuery,
  onSearchChange,
  onFilterClick,
  isSmallScreenSearchBar,
}) => {
  return (
    <Box sx={{ padding: 2, display: "flex", justifyContent: "center" }}>
      <Paper
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "3px",
          backgroundColor: "#00A3A8",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          width: isSmallScreenSearchBar ? "100%" : "66.67%",
        }}
      >
        <Paper
          sx={{
            borderRadius: "10px",
            width: "100%",
            margin: "0 0 0 5px",
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Buscar por número de pedido..."
            value={searchQuery}
            onChange={onSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "#00A3A8" }} />
                </InputAdornment>
              ),
              sx: {
                backgroundColor: "#FFFFFF",
                borderRadius: "25px",
                "& .MuiOutlinedInput-input": {
                  color: "#00A3A8",
                  padding: "5px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              },
            }}
          />
        </Paper>

        <IconButton
          title="Filtros"
          onClick={onFilterClick}
          sx={{
            marginLeft: "10px",
            color: "#FFFFFF",
          }}
        >
          <FilterListIcon />
        </IconButton>
      </Paper>
    </Box>
  );
};

export default SearchBar;
